// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  TMarkOnboardingAsViewedModel,
  IMappers,
  TMarkOnboardingAsViewedResponse,
  IMarkOnboardingAsViewedResponse,
  IMarkOnboardingAsViewedResponseError,
} from './types';

export const defaultConfig: TMarkOnboardingAsViewedModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/v1/mark-onboarding-as-viewed/',
} as TMarkOnboardingAsViewedModel;

export function createMarkOnboardingAsViewedModel(): TMarkOnboardingAsViewedModel {
  return {
    ...defaultConfig,
  };
}

export interface IMarkOnboardingAsViewedOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchMarkOnboardingAsViewed<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IMarkOnboardingAsViewedOptions<TResponse200, TResponse400>): Promise<
  TMarkOnboardingAsViewedResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createMarkOnboardingAsViewedModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMarkOnboardingAsViewedResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IMarkOnboardingAsViewedResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TMarkOnboardingAsViewedResponse;
}
